module.exports = __webpack_public_path__ + "img/super-sonar.9442f7d6.jpg";